<template>
  <div class="order-item">
    <div class="fold-btn">
      <el-button size="mini" type="text" @click="fold=!fold">
        {{ fold ? '展开': '收起' }}
        <i v-if="fold" class="crm-icon-arrow-down" /><i v-else class="crm-icon-arrow-up" />
      </el-button>
    </div>
    <div class="row order-summary">
      <div class="col-sm-5">
        <label>编号</label>
        <a :href="`/order/detail/${order.id}`">{{ order.sn }}<i class="crm-icon-arrow-right"></i></a>
      </div>
      <div class="col-sm-3">
        <label>类型</label>
        {{ order.orderType | typeFmt }}
        <el-popover v-uac="'order.togglebatch'" data-uac="order.togglebatch$$订单管理.修改批量属性" placement="bottom" popper-class="batch-toggle-popover">
          <div>
            切换：<el-switch v-model="order.isBatch" @change="toggleBatch(order)"></el-switch>
          </div>
          <span slot="reference" class="word-badge batch" :class="{ active: order.isBatch }">批</span>
        </el-popover>
        <span>
          <span class="word-badge coupon" v-if="order.couponAmount">券</span>
        </span>
      </div>
      <div class="col-sm-5">
        <div v-if="~[-1,1,2].indexOf(order.state)">
          <label>下单时间</label>{{ order.createTime | dateTimeFmt }}
        </div>
        <div v-else>
          <label>付款时间</label>{{ order.timePay | dateTimeFmt }}({{ payTypes[order.payType] }})
        </div>
      </div>
      <div class="col-sm-3">
        <label>状态</label>
        {{ stateFmt(order.state) }}
        <el-button v-if="order.state === 2" type="text" style="margin-left: 10px;padding: 0;" @click="showUmsQrCode(order)">收款码</el-button>
      </div>
      <div class="col-sm-8">
        <label>买家</label>
        <ellipsis-text :content="nameFmt(order) ">
          {{ nameFmt(order) }}
        </ellipsis-text>
      </div>
    </div>
    <div class="part-order-items" :class="{ fold: fold, collapse: collapse }">
      <div v-for="orderItem in order.orderItems" :key="orderItem.id" class="row part-order-item">
        <div class="info-item col-sm-6">
          <label>配件信息</label>
          <div>
            <div>
              <span v-if="orderItem.priceType === 1" class="badge">急件</span>
              <span v-if="orderItem.priceType === 2" class="badge">海外件</span>
              <span v-if="orderItem.priceType === 3" class="badge">兆配现货</span>
              <span v-if="orderItem.priceType === 4" class="badge">4S现货</span>
              <span v-if="orderItem.isSpot" class="badge">极速达</span>
              <span v-if="orderItem.isPromoted" class="badge">特价</span>
              <span>{{ orderItem.partName }}</span>
            </div>
            <div>
              <span style="padding-right: 4px">{{ orderItem.brandName }}</span>
              <span v-if="orderItem.supersession">
                新件：{{ orderItem.supersession }}/旧件：
              </span>
              <span>{{ orderItem.partCode }}</span>
            </div>
          </div>
        </div>
        <div class="info-item col-sm-4">
          <label>发货地</label>
          <div>{{ orderItem.warehouse }}</div>
        </div>
        <div class="col-sm-6">
          <div class="info-item">
            <label>{{ orderItem.taxed ? '含税价' : '税前价' }}</label>
            <div>{{ orderItem.price }}<span style="color:#9d9d9d">{{ orderItem | discountFmt }}</span></div>
          </div>
          <div class="info-item">
            <label>4S进价</label>
            <div>{{ orderItem.cost4S }}</div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="info-item">
            <label>下单数量</label>
            <div>
              {{ orderItem.quantity }}<a v-if="orderItem.quantityReturn" href="javascript:void(0)" @click="showReturn(orderItem.id)">(售后:{{ orderItem.quantityReturn }})</a>
            </div>
          </div>
          <item-source v-if="order.timePay && (orderItem.itemSources || []).length > 0" :order-item="orderItem"></item-source>
        </div>
        <div class="col-sm-4 ops-info-col">
          <div class="info-item">
            <label>待发数量</label>
            <div>
              {{ orderItem.quantity - orderItem.quantityReturn - orderItem.quantityDelivered }}
            </div>
          </div>
          <item-deliverable v-if="order.timePay && (orderItem.itemSources || []).length > 0" :order-item="orderItem"></item-deliverable>
          <ops-view-popover
            v-else-if="order.state === 3 && orderItem.opsInfo && (orderItem.quantity - orderItem.quantityReturn - orderItem.quantityDelivered > 0)"
            :ops-info="orderItem.opsInfo" :current-order-id="order.id"
            :wait-delivery="orderItem.quantity - orderItem.quantityReturn - orderItem.quantityDelivered"
          />
        </div>
      </div>
      <div class="row" style="text-align: center; border-top: 1px solid #d4d4d4;">
        <el-button v-if="order.orderItems.length > 3" size="mini" type="text" @click="collapse=!collapse">
          {{ collapse ? `显示剩余${order.orderItems.length - 3}项`: '收起' }}
          <i v-if="collapse" class="crm-icon-arrow-down" /><i v-else class="crm-icon-arrow-up" />
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import OpsViewPopover from './OpsViewPopover.vue'
import ItemSource from './ItemSource.vue'
import ItemDeliverable from './ItemDeliverable.vue'
import { debounceToggleBatch, UmsPlaceOrder } from '../services'
import _ from 'lodash'
export default {
  name: 'OrderItem',
  filters: {
    typeFmt (orderType) {
      return '大库订单'
    },
    discountFmt (orderItem) {
      if (orderItem.cost4S) {
        // eslint-disable-next-line no-eval
        return '（' + eval(Math.round((orderItem.price * 100) / orderItem.cost4S) + 'e-1') + '折）'
      }
      return ''
    }
  },
  components: { OpsViewPopover, ItemSource, ItemDeliverable },
  props: {
    order:
    {
      type: Object,
      default () {
        return {
          id: undefined,
          buyer: {},
          items: []
        }
      }
    }
  },
  computed: {
    payTypes () {
      return this.$store.state.payTypes
    }
  },
  data () {
    return {
      fold: true,
      collapse: true
    }
  },
  methods: {
    nameFmt (order) {
      const { companyName, passportName, passportPhone } = order.buyer || {}
      return [order.subSellerName, companyName, passportName, this.phoneShow(passportPhone)].filter(t => t).join('/')
    },
    showReturn (orderItemId) {
      this.modal('OrderReturnDetailModal', orderItemId).promise.catch(() => {})
    },
    stateFmt (orderState) {
      return this.$store.state.orderState.find(t => t.id === orderState).name
    },
    showQrCode (order) {
      this.modal('OrderQrCodeModal', order).promise.catch(() => {})
    },
    showUmsQrCode (order) {
      if (_.every(order.orderItems, part => part.taxed)) {
        UmsPlaceOrder(order).then((qrCodeResp) => {
          order.qrCode = qrCodeResp.billQrCode
          this.modal('OrderQrCodeModal', order).promise.catch(() => {})
        })
      } else {
        this.modal('OrderQrCodeModal', order).promise.catch(() => {})
      }
    },
    toggleBatch (order) {
      this.$emit('startLoading')
      debounceToggleBatch(order.id).then(() => {
        this.$emit('endLoading')
      })
    }
  }
}
</script>
